import React from 'react';
import { Layers, Leaf, Map, Plus, Search } from 'lucide-react';
import { cn } from '../lib/utils';

type NavTab = 'map' | 'plants' | 'beds' | 'search';

interface BottomNavProps {
  active: NavTab;
  onTab: (t: NavTab) => void;
  onAdd: () => void;
}

const TABS: { id: NavTab; icon: React.ReactNode; label: string }[] = [
  { id: 'map',    icon: <Map size={20} />,    label: 'Map' },
  { id: 'plants', icon: <Leaf size={20} />,   label: 'Plants' },
  { id: 'beds',   icon: <Layers size={20} />, label: 'Beds' },
  { id: 'search', icon: <Search size={20} />, label: 'Search' },
];

export function BottomNav({ active, onTab, onAdd }: BottomNavProps) {
  return (
    <div
      className="fixed bottom-0 inset-x-0 z-[800] bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 flex items-center"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      {TABS.slice(0, 2).map((tab) => (
        <NavButton key={tab.id} active={active === tab.id} onClick={() => onTab(tab.id)} icon={tab.icon} label={tab.label} />
      ))}

      {/* Center FAB */}
      <div className="flex-1 flex justify-center">
        <button
          onClick={onAdd}
          aria-label="Add plant or bed"
          className="w-12 h-12 rounded-full bg-garden-600 text-white shadow-lg flex items-center justify-center hover:bg-garden-700 active:scale-95 transition-all -mt-4"
        >
          <Plus size={22} />
        </button>
      </div>

      {TABS.slice(2).map((tab) => (
        <NavButton key={tab.id} active={active === tab.id} onClick={() => onTab(tab.id)} icon={tab.icon} label={tab.label} />
      ))}
    </div>
  );
}

function NavButton({
  active,
  onClick,
  icon,
  label,
}: {
  active: boolean;
  onClick: () => void;
  icon: React.ReactNode;
  label: string;
}) {
  return (
    <button
      onClick={onClick}
      className={cn(
        'flex-1 flex flex-col items-center gap-0.5 py-2 transition-colors',
        active ? 'text-garden-600' : 'text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300',
      )}
    >
      {icon}
      <span className="text-[10px] font-medium">{label}</span>
    </button>
  );
}
